import { FormFieldNames } from 'enums/OrgFormEnums';
import { ReportingFieldNames } from 'enums/ReportingDetailsEnums';
export interface FormValues {
  organizationName: string;
  organizationSize: string | undefined;
  sector: number | undefined;
  companyType: number | undefined;
  organizationalBoundary?: string | undefined;
}
export interface ReportValues {
  startOfReportingYear: string | undefined;
  baselineYear: string | undefined;
  recalculationThreshold: string;
}

export const organizationalBoundary = {
  equity: 'Equity share',
  financial: 'Financial control',
  operational: 'Operational control',
};

export const initialOrganizationValues = {
  [FormFieldNames.ORGANIZATION_NAME]: '',
  [FormFieldNames.ORGANIZATIONAL_BOUNDARY]: organizationalBoundary.operational,
  [FormFieldNames.ORGANIZATION_SIZE]: undefined,
  [FormFieldNames.SECTOR]: undefined,
  [FormFieldNames.COMPANY_TYPE]: undefined,
};

export const initialReportingValues = {
  [ReportingFieldNames.START_OF_REPORTING_YEAR]: undefined,
  [ReportingFieldNames.BASELINE_YEAR]: undefined,
  [ReportingFieldNames.RECALCULATION_THRESHOLD]: '',
};

export const orgBoundaryOptions = [
  {
    value: organizationalBoundary.equity,
    label: organizationalBoundary.equity,
  },
  {
    value: organizationalBoundary.financial,
    label: organizationalBoundary.financial,
  },
  {
    value: organizationalBoundary.operational,
    label: organizationalBoundary.operational,
  },
];
export const monthList = [
  { value: '1', label: 'Jan' },
  { value: '2', label: 'Feb' },
  { value: '3', label: 'Mar' },
  { value: '4', label: 'Apr' },
  { value: '5', label: 'May' },
  { value: '6', label: 'Jun' },
  { value: '7', label: 'Jul' },
  { value: '8', label: 'Aug' },
  { value: '9', label: 'Sep' },
  { value: '10', label: 'Oct' },
  { value: '11', label: 'Nov' },
  { value: '12', label: 'Dec' },
];

export const monthListWithFullName = [
  { value: 1, label: 'January' },
  { value: 2, label: 'February' },
  { value: 3, label: 'March' },
  { value: 4, label: 'April' },
  { value: 5, label: 'May' },
  { value: 6, label: 'June' },
  { value: 7, label: 'July' },
  { value: 8, label: 'August' },
  { value: 9, label: 'September' },
  { value: 10, label: 'October' },
  { value: 11, label: 'November' },
  { value: 12, label: 'December' },
];
const currentYear = new Date().getFullYear();
export const baselineYearList = Array.from(
  { length: currentYear - 2015 + 1 },
  (_, index) => {
    const year = 2015 + index;
    return { value: year, label: year.toString(), key: year };
  }
);
export const categoryList = [
  {
    label: 'Processing facility',
    value: 'Processing facility',
    key: 'processing_facility',
  },
  { label: 'Warehouse', value: 'Warehouse', key: 'warehouse' },
  {
    label: 'Office building',
    value: 'Office building',
    key: 'office_building',
  },
  { label: 'Retail store', value: 'Retail store', key: 'retail_store' },
  {
    label: 'Distribution centre',
    value: 'Distribution centre',
    key: 'distribution_centre',
  },
  { label: 'Farm', value: 'Farm', key: 'farm' },
  { label: 'Barn/Hatchery', value: 'Barn/Hatchery', key: 'barn_hatchery' },
  { label: 'Mills', value: 'Mills', key: 'mills' },
];

export const transformToPayload = (values: FormValues) => {
  return {
    data: {
      company: {
        size: {
          id: values.organizationSize || undefined,
        },
        sector: {
          id: values.sector || undefined,
        },
        company_type: {
          id: values.companyType || undefined,
        },
        organizational_boundary: values.organizationalBoundary || '',
        reporting_month: 1,
        baseline_year: 0,
        recalculation_threshold: 0,
      },
      organization: {
        name: values.organizationName || '',
      },
    },
  };
};
export const PostalCodeError = 'Postal code should be alpha numeric';

// Utility function to find month label from monthList
const getMonthLabel = (month: string): string | undefined => {
  const monthItem = monthList.find(m => m.value === String(parseInt(month)));
  return monthItem?.label;
};

// Function to convert the date range format
export const formatDateRange = (dateRange: string): string => {
  const noSpacesRange = dateRange.replace(/\s+/g, '');
  const [start, end] = noSpacesRange?.split('-');

  const [startMonth, startYear] = start?.split('/');
  const [endMonth, endYear] = end?.split('/');

  const formattedStart = `${getMonthLabel(startMonth)} ${startYear}`;
  const formattedEnd = `${getMonthLabel(endMonth)} ${endYear}`;

  return `${formattedStart} - ${formattedEnd}`;
};
